import { useState } from "react"

export const useGlobalStates = () => {
    
    const [ showForm, setShowForm ] = useState(false)
    const [ modalOpeningMode, setModalOpeningMode ] = useState('EDITABLE')
    const [ loadingSubmitForm, setLoadingSubmitForm ] = useState(false)

    return Object.freeze({
        showForm, setShowForm,
        modalOpeningMode, setModalOpeningMode,
        loadingSubmitForm, setLoadingSubmitForm
    })
}